"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberRound = void 0;
const precisions = [1, 10, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8];
/**
 * zaokrągla liczbę zmiennoprzecinkową uwzględniając przekłamania JS
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function numberRound(value, precision = 2) {
    if (value === undefined) {
        return value;
    }
    if (value % 1 === 0) {
        return value;
    }
    else {
        return Math.round(value * precisions[precision] + 0.0000000000001) / precisions[precision];
    }
}
exports.numberRound = numberRound;
//# sourceMappingURL=numberRound.js.map